import React, { Component } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import { MDBBtn, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon, MDBBadge, MDBContainer, MDBRow, MDBCol, MDBNavbar, MDBNavbarToggler, MDBCollapse, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBDropdownMenu, MDBDropdownItem, MDBDropdown, MDBDropdownToggle} from "mdbreact";
import logo from './logo.svg';
import './Nav.css';

import { BrowserRouter as Router } from 'react-router-dom';

class MyNav extends Component {
  state = {
    isOpen: false
  };
  
  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {

  return (
      <MDBContainer className="pb-4">
       <Router>
      <MDBNavbar light expand="md" className="navigation-clean mt-2 z-depth-0">
        <MDBNavbarToggler onClick={this.toggleCollapse} />
        <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
        <MDBNavbarNav>
          <MDBNavItem >
            <a href="/" className="nav-link">Home</a>
          </MDBNavItem>
          <MDBDropdown>
            <MDBDropdownToggle nav caret>
              <span className="mr-2">My Services</span>
            </MDBDropdownToggle>
            <MDBDropdownMenu>
              <MDBDropdownItem href="/marriage/">Marriage Services</MDBDropdownItem>
              <MDBDropdownItem href="/vow-renewal/">Renewal of Vows</MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
          <MDBNavItem >
            <a href="/why-me/" className="nav-link">Why Me</a>
          </MDBNavItem>
          <MDBNavItem >
            <a href="/about/" className="nav-link">About Me</a>
          </MDBNavItem>
          <MDBNavItem >
            <a href="/testimonials/" className="nav-link">Testimonials</a>
          </MDBNavItem>
          <MDBNavItem >
            <a href="/faq/" className="nav-link">FAQ</a>
          </MDBNavItem>
          <MDBNavItem >
            <a href="/contact/" className="nav-link">Contact</a>
          </MDBNavItem>
          <MDBNavItem >
            <a href="/book-me/" className="nav-link">Book Me</a>
          </MDBNavItem>
        </MDBNavbarNav>
        </MDBCollapse>
      </MDBNavbar>
      </Router>
      <hr />

      </MDBContainer>

      

  );}

}

export default MyNav;
